export default "__VITE_ASSET__U50znu4v__"